import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface ModalState {
  isOpen: boolean;
  modalType: string | null;
  props: any;
}

const initialState: ModalState = {
  isOpen: false,
  modalType: null,
  props: {},
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<{ modalType: string; props: any }>) => {
      state.isOpen = true;
      state.modalType = action.payload.modalType;
      state.props = action.payload.props;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.modalType = null;
      state.props = {};
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export const modalSelector = (state: RootState) => state.modal;
export default modalSlice.reducer;
